import { render, staticRenderFns } from "./StudyContainer.vue?vue&type=template&id=07ef642a&scoped=true&"
import script from "./StudyContainer.vue?vue&type=script&lang=js&"
export * from "./StudyContainer.vue?vue&type=script&lang=js&"
import style0 from "./StudyContainer.vue?vue&type=style&index=0&id=07ef642a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ef642a",
  null
  
)

export default component.exports